<template>
  <div class="app-container">
    <div style="position: absolute;top: 70px;left: 650px;" v-if="active == 'rentRecord'">
      <el-alert title="注：添加出租记录后自动生成收租记录，以首次收租日期为及准，按开始至结束日期间隔月数及支付类型生成！" type="success" show-icon></el-alert>
    </div>
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <el-tabs v-model="active" @tab-click="tabClick" v-if="showTabs">
          <el-tab-pane label="出租记录" name="rentRecord">
            <rent-record ref="rentRecord" :room-id="roomId" :rooms="rooms"></rent-record>
          </el-tab-pane>
          <el-tab-pane label="收租记录" name="collectRecord">
            <collect-record ref="collectRecord"  :room-id="roomId" :rent-records="rentRecords"></collect-record>
          </el-tab-pane>
          <el-tab-pane label="退租记录" name="breakRecord">
            <break-record ref="breakRecord"  :room-id="roomId" :rent-records="rentRecords"></break-record>
          </el-tab-pane>
          <el-tab-pane label="中介记录" name="agencyRecord">
            <agency-record ref="agencyRecord"  :room-id="roomId" :rent-records="rentRecords"></agency-record>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>

import RentRecord from "@/components/RentRecord";
import CollectRecord from "@/components/CollectRecord";
import BreakRecord from "@/components/BreakRecord";
import AgencyRecord from "@/components/AgencyRecord";
import {getList as getRooms} from "@/api/room";
import {getList as getRentRecords} from "@/api/rentRecord";

export default {
  components: {
    RentRecord,
    CollectRecord,
    BreakRecord,
    AgencyRecord
  },
  data() {
    return {
      active: 'rentRecord',
      roomId: 0,
      rooms: [],
      rentRecords: [],
      showTabs: false
    }
  },
  mounted() {
    this.roomId = parseInt(this.$route.query.roomId)
    setTimeout(() => {
      this.getRooms()
      this.getRentRecords()
    }, 100);
  },
  methods: {
    getRentRecords() {
      const params = {
        roomId: this.roomId
      }
      getRentRecords(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.rentRecords = response.data
          this.showTabs = true
        }
      })
    },
    getRooms() {
      getRooms().then(response => {
        if (response.code == 200) {
          // 查询成功
          this.rooms = response.data
        }
      })
    },
    tabClick() {
      const tab = this.active
      if (tab == 'rentRecord') {
        this.$refs['rentRecord'].search(true)
      } else if (tab == 'collectRecord') {
        this.$refs['collectRecord'].search(true)
      } else if (tab == 'breakRecord') {
        this.$refs['breakRecord'].search(true)
      } else if (tab == 'agencyRecord') {
        this.$refs['agencyRecord'].search(true)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/back/roomDetail.vue